import React, {useState} from 'react';

import { Dialog, withStyles } from '@material-ui/core';
import { hasPermission } from '../../../../sc-utilities';
import PlansForm from './PlansForm';
import * as Yup from 'yup';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    }
});

const PlansEdit = props => {
    const { open, plans, billingAccount, classes, activeCustomerID, translations, permissions, assignPlans, modifyPlansState, handlePlansEdit, onLoadAccount, onFetchPlanVersions } = props;

    const [planVersions, setPlanVersions] = useState(null);

    const extractPlanIds = selectPlanIds => {
        return selectPlanIds.map(planId => planId.value);
    }

    const submitHandler = async data => {
        let formData = { ...data }
        formData['ActiveAccountID'] = !billingAccount.loaded.AccountID ? modifyPlansState ? modifyPlansState.billingAccountID : null : billingAccount.loaded.AccountID;
        formData['PlanIDs'] = [...extractPlanIds(prepareFields()), formData.PlanID];
        await assignPlans({ ...formData, ActiveCustomerID: activeCustomerID });
        await handlePlansEdit();
        onLoadAccount({ ActiveAccountID: formData['ActiveAccountID'], ActiveCustomerID: activeCustomerID });
    };

    const cancelHandler = async () => {
        await handlePlansEdit(null, true);
    };

    const prepareFields = () => {
        if (billingAccount && billingAccount.accountPlans && billingAccount.accountPlans.list) {
            let accountPlansIds = billingAccount.accountPlans.list.map(billAccount => billAccount?.PlanID)
            return plans.filter(plan => accountPlansIds.includes(plan.value))
        }
    }

    const unassignedPlans = () => {
        if (billingAccount && billingAccount.accountPlans && billingAccount.accountPlans.list) {
            let accountPlansIds = billingAccount.accountPlans.list.map(billAccount => billAccount?.PlanID)
            return plans.filter(plan => !accountPlansIds.includes(plan.value))
        }
    }

    let initialValues = {
        // PlanIDs: prepareFields() || []
        PlanID: null,
        StickWithPreviousVersion: false,
        VersionID: "",
    };

    let formSettings = {
        Validation: {
            PlanID: Yup.string().required(),
            StickWithPreviousVersion: Yup.boolean(),
            VersionID: Yup.string().when("StickWithPreviousVersion", {
                is: true,
                then: Yup.string().required()
            })
        },
        FormTitle: translations['update_account_plans'] || "Update account plans",
        ButtonSubmit: hasPermission(permissions, 'billing_account_plan_assign') ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown={false}
            fullWidth={true}
            onClose={cancelHandler}
        >
            <div className={classes.root}>
                <PlansForm handleSubmit={submitHandler} plans={unassignedPlans()} planVersions={planVersions} setPlanVersions={setPlanVersions} onFetchPlanVersions={onFetchPlanVersions} activeCustomerID={activeCustomerID} translations={translations} initialValues={initialValues} formSettings={formSettings} />
            </div>
        </Dialog>
    )
};

export default withStyles(styles, { withTheme: true })(PlansEdit);